import React from "react";
import Heading from "../Heading/Heading";
import "./Card.scss";
export type size = "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
export type view = "mfg-list" | "mfg-grid";
export interface Props {
  cardHeading?: any;
  CardHeadingType?: size;
  CardHeadingClass?: any;
  CardHeadingId?: any;
  cardBodyChildren?: any;
  cardFooterChildren?: any;
  CardBodyClass?: any;
  CardFooterClass?: any;
  CardBodyId?: any;
  CardFooterId?: any;
  CardImagePath?: any;
  CardImageAlt?: any;
  CardView?: view;
  cardContentClass?: string;
  CardCustomClass?: string;
}

export const Card = ({
  cardHeading,
  cardBodyChildren,
  cardFooterChildren,
  CardBodyClass,
  CardHeadingClass,
  CardBodyId,
  CardHeadingId,
  CardHeadingType = "h2",
  CardImagePath,
  CardImageAlt,
  CardFooterClass,
  CardFooterId,
  CardView = "mfg-grid",
  cardContentClass,
  CardCustomClass,
}: Props) => {
  return (
    <div
      className={`mfg-card${CardView ? " " + CardView : ""}${
        CardCustomClass ? " " + CardCustomClass : ""
      }`}
    >
      {CardImagePath && (
        <div className="cardImage">
          <img src={CardImagePath} alt={CardImageAlt} />
        </div>
      )}
      <div
        className={`cardContent${
          cardContentClass ? " " + cardContentClass : ""
        }${
          (cardHeading || cardBodyChildren || cardFooterChildren) &&
          CardImagePath
            ? " " + "contentPadding"
            : ""
        }${
          (cardHeading || cardBodyChildren || cardFooterChildren) &&
          !CardImagePath
            ? " " + "contentPaddingFull"
            : ""
        }`}
      >
        {cardHeading && (
          <Heading
            Type={CardHeadingType}
            HeadingClass={`cardHeading${
              CardHeadingClass ? " " + CardHeadingClass : ""
            }`}
            HeadingId={CardHeadingId}
          >
            {cardHeading}
          </Heading>
        )}
        {cardBodyChildren && (
          <div
            className={`cBody${CardBodyClass ? " " + CardBodyClass : ""}`}
            id={CardBodyId}
          >
            {cardBodyChildren}
          </div>
        )}
        {cardFooterChildren && (
          <div
            className={`cFooter${CardFooterClass ? " " + CardFooterClass : ""}`}
            id={CardFooterId}
          >
            {cardFooterChildren}
          </div>
        )}
      </div>
    </div>
  );
};

export default Card;
